module.exports = require("core-js/library/fn/object/get-own-property-symbols");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-own-property-symbols.js
// module id = 1253
// module chunks = 0